import { Kampanya } from "@/mocks/kampanyalar";

interface KampanyaDetayModalProps {
  kampanya: Kampanya;
  onClose: () => void;
}

const kisiListesi = [
  { ad: "Ayşe Yılmaz", telefon: "0532 111 2233", durum: "Gönderildi", tarih: "19 May 10:32" },
  { ad: "Mehmet Demir", telefon: "0533 222 3344", durum: "Bekliyor", tarih: "-" },
  { ad: "Fatma Kaya", telefon: "0534 333 4455", durum: "Gönderildi", tarih: "19 May 10:26" },
  { ad: "Ahmet Çelik", telefon: "0535 444 5566", durum: "Gönderildi", tarih: "19 May 10:20" },
  { ad: "Hatice Arslan", telefon: "0536 555 6677", durum: "Bekliyor", tarih: "-" },
  { ad: "İbrahim Şahin", telefon: "0537 666 7788", durum: "Gönderildi", tarih: "19 May 10:14" },
  { ad: "Meryem Doğan", telefon: "0538 777 8899", durum: "Hatalı", tarih: "19 May 10:08" },
  { ad: "Ömer Yıldız", telefon: "0539 888 9900", durum: "Bekliyor", tarih: "-" },
];

function DurumChip({ durum }: { durum: string }) {
  const map: Record<string, string> = {
    "Gönderildi": "bg-emerald-100 text-emerald-700",
    "Bekliyor": "bg-amber-100 text-amber-700",
    "Hatalı": "bg-red-100 text-red-600",
  };
  return (
    <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${map[durum] || "bg-gray-100 text-gray-600"}`}>
      {durum}
    </span>
  );
}

export default function KampanyaDetayModal({ kampanya, onClose }: KampanyaDetayModalProps) {
  const progress = kampanya.toplamKisi > 0 ? Math.round((kampanya.gonderilen / kampanya.toplamKisi) * 100) : 0;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col shadow-2xl">
        {/* Header */}
        <div className="bg-[#0B1120] px-6 py-5 flex items-center justify-between">
          <div>
            <h2 className="text-white font-bold text-base">{kampanya.ad}</h2>
            <p className="text-gray-400 text-xs mt-0.5">{kampanya.tip} · {kampanya.hedefKitle}</p>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/10 text-gray-400 hover:text-white cursor-pointer transition-colors"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="overflow-y-auto flex-1">
          <div className="p-6 space-y-6">
            {/* Özet */}
            <section>
              <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Kampanya Özeti</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{kampanya.aciklama}</p>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4">
                {[
                  { label: "Toplam Kişi", value: kampanya.toplamKisi, color: "text-gray-800" },
                  { label: "Gönderilen", value: kampanya.gonderilen, color: "text-emerald-600" },
                  { label: "Bekleyen", value: kampanya.bekleyen, color: "text-amber-600" },
                  { label: "Hatalı", value: kampanya.hatali, color: "text-red-500" },
                ].map((s) => (
                  <div key={s.label} className="bg-gray-50 rounded-xl p-4 text-center">
                    <p className={`text-2xl font-bold ${s.color}`}>{s.value}</p>
                    <p className="text-xs text-gray-400 mt-1">{s.label}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Hedef Kitle */}
            <section>
              <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Hedef Kitle</h3>
              <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100">
                <div className="w-10 h-10 rounded-xl bg-[#0B1120] flex items-center justify-center text-[#25D366]">
                  <i className="ri-group-line text-base"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-800">{kampanya.hedefKitle}</p>
                  <p className="text-xs text-gray-500">{kampanya.toplamKisi} kişi seçildi</p>
                </div>
              </div>
            </section>

            {/* Mesaj Önizleme */}
            <section>
              <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Mesaj Önizleme</h3>
              <div className="flex justify-center">
                <div className="w-64 bg-[#E5DDD5] rounded-[28px] p-4 relative" style={{ backgroundImage: "url(https://readdy.ai/api/search-image?query=whatsapp%20chat%20background%20subtle%20pattern%20very%20light%20green%20texture&width=256&height=320&seq=wpbg1&orientation=portrait)", backgroundSize: "cover" }}>
                  <div className="absolute inset-0 bg-[#E5DDD5]/80 rounded-[28px]"></div>
                  <div className="relative">
                    <div className="bg-white rounded-tl-none rounded-tr-2xl rounded-br-2xl rounded-bl-2xl p-3 max-w-[90%] shadow-sm">
                      <p className="text-[13px] text-gray-800 leading-relaxed">
                        {kampanya.mesajSablonu
                          .replace(/%veli_adi/g, "Ayşe Hanım")
                          .replace(/%ogrenci_adi/g, "Kerem")
                          .replace(/%odeme_tarihi/g, "5 Haziran")
                          .replace(/%taahhut_bitis_tarihi/g, "15 Ağustos 2026")
                          .replace(/%kampanya_adi/g, kampanya.ad)}
                      </p>
                      <p className="text-[10px] text-gray-400 text-right mt-1.5">14:32 ✓✓</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Gönderim İlerlemesi */}
            <section>
              <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Gönderim İlerlemesi</h3>
              <div className="space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">%{progress} tamamlandı</span>
                  <span className="text-gray-400 text-xs">{kampanya.gonderilen} / {kampanya.toplamKisi}</span>
                </div>
                <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-emerald-400 rounded-full transition-all"
                    style={{ width: `${progress}%` }}
                  />
                </div>
                <div className="flex items-center gap-4 text-xs text-gray-400 mt-2">
                  <span>Başlangıç: {kampanya.baslamaTarihi}</span>
                  <span>·</span>
                  <span>Son: {kampanya.sonGonderim}</span>
                </div>
              </div>
            </section>

            {/* Kişi Listesi */}
            <section>
              <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Kişi Listesi</h3>
              <div className="border border-gray-100 rounded-xl overflow-hidden">
                <table className="w-full">
                  <thead className="bg-gray-50/50">
                    <tr>
                      <th className="text-left px-4 py-2.5 text-xs font-semibold text-gray-500">Veli Adı</th>
                      <th className="text-left px-4 py-2.5 text-xs font-semibold text-gray-500 hidden sm:table-cell">Telefon</th>
                      <th className="text-left px-4 py-2.5 text-xs font-semibold text-gray-500">Durum</th>
                      <th className="text-left px-4 py-2.5 text-xs font-semibold text-gray-500 hidden sm:table-cell">Gönderim</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {kisiListesi.map((k, i) => (
                      <tr key={i} className="hover:bg-gray-50/50">
                        <td className="px-4 py-2.5 text-sm text-gray-800">{k.ad}</td>
                        <td className="px-4 py-2.5 text-xs text-gray-500 hidden sm:table-cell">{k.telefon}</td>
                        <td className="px-4 py-2.5"><DurumChip durum={k.durum} /></td>
                        <td className="px-4 py-2.5 text-xs text-gray-400 hidden sm:table-cell">{k.tarih}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="text-xs text-gray-400 mt-2">Toplam {kampanya.toplamKisi} kişiden 8 tanesi gösteriliyor</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}